<template>
    <div class="convention-tools" v-if="user">
        <action
            name="link"
            class="print"
            with-icon="mdi-printer"
            :nochevron="true"
            :small="true"
            @click="printWindow()"
        >
            Imprimer
        </action>
        <convention-select-action
            v-if="!displayPrintFormat"
            :parentConvention="parentConvention"
            :user="user"
        />
    </div>
</template>

<script>
import ConventionSelectAction from "./ConventionSelectAction.vue";
import { EventBus } from "src/bus/eventBus";

export default {
    props: ["parentConvention", "user", "displayPrintFormat"],
    components: { ConventionSelectAction },
    methods: {
        printWindow() {
            EventBus.$emit("convention:will-print");
            this.$nextTick(() => {
                window.print();
            });
        },
    },
};
</script>

<style scoped lang="sass">
.convention-tools
    display: flex
    justify-content: flex-end

.print
    margin-right: $grid-gutter

::v-deep .action
    outline: transparent

@media print
    .convention-tools
        display: none
</style>
